import i18next, { Resource } from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend'
import config from 'constants/config'
import { defaultNamespace, supportedLngs, fallbackLng, showI18nStringsPostProcessor } from './sharedConfig'
import addFormatters, { addCurrencyFormatter } from './formatters'
import { reportError } from 'services/errorReportingService'

const { language, regionCode, currencyCode, initialResources, showI18NStrings } = window.__I18N__ as {
  language: string,
  regionCode: string,
  currencyCode: string,
  showI18NStrings: boolean,
  initialResources: Resource,
}

i18next
  .use(initReactI18next)
  .use(HttpBackend)
  .use(showI18nStringsPostProcessor)
  .init<HttpBackendOptions>({
    ns: defaultNamespace,
    lng: language,
    supportedLngs,
    fallbackLng,
    partialBundledLanguages: true,
    resources: initialResources,
    saveMissing: config.I18N_DEV_MODE,
    postProcess: showI18NStrings ? ['showI18nStrings'] : undefined,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    missingKeyHandler: (lngs, ns, key, fallbackValue, updateMissing, options) => {
      // Add it to the local store so we don't keep sending requests for the same key
      i18next.addResource('en', ns, key, fallbackValue)
      if (config.I18N_DEV_MODE && i18next.services.backendConnector?.saveMissing) {
        i18next.services.backendConnector.saveMissing('en', ns, key, fallbackValue, updateMissing, options)
      }
      // There is a missing key in test/production, send it to Sentry
      if (config.I18N_PROD_MODE) {
        reportError(new Error(`Missing i18n key: ${key} in namespace: ${ns}`),
          { feature: 'i18n', key, ns },
          undefined,
          { i18n: 'missingKey' },
        )
      }
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: '/locales/add/{{lng}}/{{ns}}',
    },
  })

addFormatters(i18next)
addCurrencyFormatter(i18next, regionCode, currencyCode)

export default i18next
